import { TURBINE_LAST_UPDATE, TURBINE_STATUS_UPDATE } from "../constants";

const initialState = {};

export default (state = initialState, action) => {
  switch (action.type) {
    case TURBINE_LAST_UPDATE: {
      const { windTurbineId } = action.payload;
      return {
        ...state,
        [windTurbineId]: {
          ...state[windTurbineId],
          lastUpdate: action.payload.data,
        },
      };
    }

    // Pushed from the bridge's MQTT "status" message (LWT offline, or
    // plcOnline flipping) - lastUpdate is left untouched here on purpose, so
    // the "last online" timestamp shown in the Timeout banner keeps meaning
    // "last time real telemetry arrived", not "last time we heard anything".
    case TURBINE_STATUS_UPDATE: {
      const { windTurbineId } = action.payload;
      return {
        ...state,
        [windTurbineId]: {
          ...state[windTurbineId],
          online: action.payload.data,
          plcOnline: action.payload.plcOnline,
        },
      };
    }

    default:
      return state;
  }
};
